/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Freebsd_3Inputs */

const en_pc_dl_freebsd_3 = /** @type {(inputs: Pc_Dl_Freebsd_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run the pdfcraft binary from the extracted folder.`)
};

const zh_pc_dl_freebsd_3 = /** @type {(inputs: Pc_Dl_Freebsd_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在解压目录中运行 pdfcraft 程序。`)
};

/**
* | output |
* | --- |
* | "Run the pdfcraft binary from the extracted folder." |
*
* @param {Pc_Dl_Freebsd_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_freebsd_3 = /** @type {((inputs?: Pc_Dl_Freebsd_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Freebsd_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_freebsd_3(inputs)
	return zh_pc_dl_freebsd_3(inputs)
});
export { pc_dl_freebsd_3 as "pc.dl.freebsd.3" }